export const UserGroupIcon = (props) => (
  <svg fill="none" height={24} viewBox="0 0 24 24" width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M20.5 19.5C20.5 17.41 18.83 14.432 16.5 13.773M14.5 19.5C14.5 16.849 11.814 13.5 8.5 13.5C5.186 13.5 2.5 16.849 2.5 19.5M14.5 10C15.2956 10 16.0587 9.68393 16.6213 9.12132C17.1839 8.55871 17.5 7.79565 17.5 7C17.5 6.20435 17.1839 5.44129 16.6213 4.87868C16.0587 4.31607 15.2956 4 14.5 4M11.5 7C11.5 7.79565 11.1839 8.55871 10.6213 9.12132C10.0587 9.68393 9.29565 10 8.5 10C7.70435 10 6.94129 9.68393 6.37868 9.12132C5.81607 8.55871 5.5 7.79565 5.5 7C5.5 6.20435 5.81607 5.44129 6.37868 4.87868C6.94129 4.31607 7.70435 4 8.5 4C9.29565 4 10.0587 4.31607 10.6213 4.87868C11.1839 5.44129 11.5 6.20435 11.5 7Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
  </svg>
);
